import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-secondary-950 text-white">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-flashlight-fill text-lg text-white"></i>
                </div>
                <span className="text-xl font-heading font-bold tracking-wide">
                  极速体育
                </span>
              </div>
              <p className="text-sm text-foreground-300 leading-relaxed">
                极速体育——为体育迷提供最快速的实时赛事直播、比分更新、体育资讯与赛事分析。足球、篮球、网球等全项目覆盖。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4 text-white">热门分类</h4>
              <div className="flex flex-col gap-2">
                {["足球", "篮球", "网球", "电竞", "F1赛车"].map((name) => (
                  <Link
                    key={name}
                    to={`/category/${name === "F1赛车" ? "f1" : name === "电竞" ? "esports" : name === "足球" ? "football" : name === "篮球" ? "basketball" : "tennis"}`}
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {name}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4 text-white">快捷链接</h4>
              <div className="flex flex-col gap-2">
                <Link to="/" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">首页</Link>
                <Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">关于我们</Link>
                <a href="#" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">会员中心</a>
                <a href="#" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">帮助中心</a>
                <a href="#" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">隐私政策</a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4 text-white">联系我们</h4>
              <div className="flex flex-col gap-2">
                <div className="flex items-center gap-2 text-sm text-foreground-300">
                  <i className="ri-phone-line"></i>
                  <span>400-888-8888</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-foreground-300">
                  <i className="ri-mail-line"></i>
                  <span>support@jisusports.com</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-foreground-300">
                  <i className="ri-map-pin-line"></i>
                  <span>北京市朝阳区体育中心路88号</span>
                </div>
              </div>
            </div>
          </div>

          <div className="border-t border-foreground-700/30 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              &copy; 2026 极速体育 JisuSports.com 版权所有 | 京ICP备2026080801号
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">服务条款</a>
              <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
              <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}